import { Sort } from '@empathy/search-types';

export const SEARCH_ACTIONS_KEYS = {
  clearAllFiltersAndSelectOne: 'clearAllFiltersAndSelectOne',
  clearFacetsFilters: 'clearFacetsFilters',
  clearSearch: 'clearSearch',
  closeFacetsPanels: 'closeFacetsPanels',
  deselectFilter: 'deselectFilter',
  loadPreselectedFilters: 'loadPreselectedFilters',
  redirect: 'redirect',
  resetFacetsCollapse: 'resetFacetsCollapse',
  search: 'search',
  selectFilter: 'selectFilter',
  setFacetsGroupsFromConfig: 'setFacetsGroupsFromConfig',
  setRemainingFacets: 'setRemainingFacets',
  toggleFilter: 'toggleFilter'
} as const;

export const SEARCH_GETTERS_KEYS = {
  compulsoryFacets: 'compulsoryFacets',
  gridItems: 'gridItems',
  hasMoreResults: 'hasMoreResults',
  hasResults: 'hasResults',
  infiniteScrollEnabled: 'infiniteScrollEnabled',
  resultsCallbackInfo: 'resultsCallbackInfo',
  remainingFacets: 'remainingFacets',
  searchBoxSuggestion: 'searchBoxSuggestion',
  searchHasNoResults: 'searchHasNoResults',
  searchRequest: 'searchRequest',
  searchRequestNextQueryResults: 'searchRequestNextQueryResults',
  selectedFilters: 'selectedFilters',
  selectedFiltersByFacet: 'selectedFiltersByFacet',
  selectedFiltersByGroup: 'selectedFiltersByGroup',
  selectedFiltersCount: 'selectedFiltersCount',
  selectedRootFiltersByFacet: 'selectedRootFiltersByFacet',
  showEmptySearch: 'showEmptySearch',
  showFallbackFilters: 'showFallbackFilters',
  showNoResults: 'showNoResults',
  showPartials: 'showPartials'
} as const;

export const SEARCH_MUTATIONS_KEYS = {
  addFacetsToGroup: 'addFacetsToGroup',
  clearFilters: 'clearFilters',
  clearPage: 'clearPage',
  clearPartialResults: 'clearPartialResults',
  clearSearch: 'clearSearch',
  deselectFilter: 'deselectFilter',
  increasePage: 'increasePage',
  saveSearchResponse: 'saveSearchResponse',
  selectFilter: 'selectFilter',
  setFacetCollapse: 'setFacetCollapse',
  setFacets: 'setFacets',
  setFacetsGroups: 'setFacetsGroups',
  setFacetsPanelCollapsed: 'setFacetsPanelCollapsed',
  setKeepPreviousResults: 'setKeepPreviousResults',
  setLoading: 'setLoading',
  setPage: 'setPage',
  setPreselectedFilters: 'setPreselectedFilters',
  setFacetsFromPreselectedFilters: 'setFacetsFromPreselectedFilters',
  setQuery: 'setQuery',
  setSort: 'setSort',
  toggleFilter: 'toggleFilter',
  updateFilterValue: 'updateFilterValue',
  updateResult: 'updateResult'
} as const;

export const DEFAULT_SORT: Sort = { title: 'default', value: '', direction: null };
